!function(t,i,e){var n=window.matchMedia;"undefined"!=typeof module&&module.exports?module.exports=e(n):"function"==typeof define&&define.amd?define(function(){return i[t]=e(n)}):i[t]=e(n)}("enquire",this,function(t){"use strict";function i(t,i){for(var e=0,n=t.length;n>e&&!1!==i(t[e],e);e++);}function e(t){return"function"==typeof t}function n(t){this.options=t,!t.deferSetup&&this.setup()}function s(i,e){this.query=i,this.isUnconditional=e,this.handlers=[],this.mql=t(i);var n=this;this.listener=function(t){n.mql=t,n.assess()},this.mql.addListener(this.listener)}function o(){if(!t)throw new Error("matchMedia not present, legacy browsers require a polyfill");this.queries={},this.browserIsIncapable=!t("only all").matches}return n.prototype={setup:function(){this.options.setup&&this.options.setup(),this.initialised=!0},on:function(){!this.initialised&&this.setup(),this.options.match&&this.options.match()},off:function(){this.options.unmatch&&this.options.unmatch()},destroy:function(){this.options.destroy?this.options.destroy():this.off()},equals:function(t){return this.options===t||this.options.match===t}},s.prototype={addHandler:function(t){var i=new n(t);this.handlers.push(i),this.matches()&&i.on()},removeHandler:function(t){var e=this.handlers;i(e,function(i,n){return i.equals(t)?(i.destroy(),!e.splice(n,1)):void 0})},matches:function(){return this.mql.matches||this.isUnconditional},clear:function(){i(this.handlers,function(t){t.destroy()}),this.mql.removeListener(this.listener),this.handlers.length=0},assess:function(){var t=this.matches()?"on":"off";i(this.handlers,function(i){i[t]()})}},o.prototype={register:function(t,n,o){var r=this.queries,h=o&&this.browserIsIncapable;return r[t]||(r[t]=new s(t,h)),e(n)&&(n={match:n}),function(t){return"[object Array]"===Object.prototype.toString.apply(t)}(n)||(n=[n]),i(n,function(i){e(i)&&(i={match:i}),r[t].addHandler(i)}),this},unregister:function(t,i){var e=this.queries[t];return e&&(i?e.removeHandler(i):(e.clear(),delete this.queries[t])),this}},new o}),function(t){t.fn.equalHeights=function(){var i=0,e=t(this);return e.each(function(){var e=t(this).innerHeight();e>i&&(i=e)}),e.css("height",i)},t("[data-equal]").each(function(){var i=t(this),e=i.data("equal");i.find(e).equalHeights()})}(jQuery);var afterResize=function(){var t={};return function(i,e,n){n||(n="Don't call this twice without a uniqueId"),t[n]&&clearTimeout(t[n]),t[n]=setTimeout(i,e)}}();

//* Ajaxify.js.liquid *//



window.theme=window.theme||{},theme.Sections=function(){this.constructors={},this.instances=[],$(document).on("shopify:section:load",this._onSectionLoad.bind(this)).on("shopify:section:unload",this._onSectionUnload.bind(this)).on("shopify:section:select",this._onSelect.bind(this)).on("shopify:section:deselect",this._onDeselect.bind(this)).on("shopify:block:select",this._onBlockSelect.bind(this)).on("shopify:block:deselect",this._onBlockDeselect.bind(this))},theme.Sections.prototype=_.assignIn({},theme.Sections.prototype,{_createInstance:function(e,t){var n=$(e),i=n.attr("data-section-id"),a=n.attr("data-section-type");if(t=t||this.constructors[a],!_.isUndefined(t)){var o=_.assignIn(new t(e),{id:i,type:a,container:e});this.instances.push(o)}},_onSectionLoad:function(e){var t=$("[data-section-id]",e.target)[0];t&&this._createInstance(t)},_onSectionUnload:function(e){this.instances=_.filter(this.instances,function(t){var n=t.id===e.detail.sectionId;return n&&_.isFunction(t.onUnload)&&t.onUnload(e),!n})},_onSelect:function(e){var t=_.find(this.instances,function(t){return t.id===e.detail.sectionId});!_.isUndefined(t)&&_.isFunction(t.onSelect)&&t.onSelect(e)},_onDeselect:function(e){var t=_.find(this.instances,function(t){return t.id===e.detail.sectionId});!_.isUndefined(t)&&_.isFunction(t.onDeselect)&&t.onDeselect(e)},_onBlockSelect:function(e){var t=_.find(this.instances,function(t){return t.id===e.detail.sectionId});!_.isUndefined(t)&&_.isFunction(t.onBlockSelect)&&t.onBlockSelect(e)},_onBlockDeselect:function(e){var t=_.find(this.instances,function(t){return t.id===e.detail.sectionId});!_.isUndefined(t)&&_.isFunction(t.onBlockDeselect)&&t.onBlockDeselect(e)},register:function(e,t){this.constructors[e]=t,$("[data-section-type="+e+"]").each(function(e,n){this._createInstance(n,t)}.bind(this))}}),theme.a11y={pageLinkFocus:function(e){var t="js-focus-hidden";e.first().attr("tabIndex","-1").focus().addClass(t).one("blur",function(){e.first().removeClass(t).removeAttr("tabindex")})},focusHash:function(){var e=window.location.hash;e&&document.getElementById(e.slice(1))&&this.pageLinkFocus($(e))},bindInPageLinks:function(){$("a[href*=#]").on("click",function(e){this.pageLinkFocus($(e.currentTarget.hash))}.bind(this))},trapFocus:function(e){var t=e.namespace?"focusin."+e.namespace:"focusin";e.$elementToFocus||(e.$elementToFocus=e.$container),e.$container.attr("tabindex","-1"),e.$elementToFocus.focus(),$(document).on(t,function(t){e.$container[0]===t.target||e.$container.has(t.target).length||e.$container.focus()})},removeTrapFocus:function(e){var t=e.namespace?"focusin."+e.namespace:"focusin";e.$container&&e.$container.length&&e.$container.removeAttr("tabindex"),$(document).off(t)}},window.timber=window.timber||{},timber.cacheSelectors=function(){timber.cache={$html:$("html"),$body:$("body"),$window:$(window),$breadcrumbs:$(".breadcrumb"),$navigation:$("#AccessibleNav"),$mobileNav:$("#MobileNav"),$hasDropdownItem:$(".site-nav--has-dropdown"),$menuToggle:$(".menu-toggle"),$productImageWrap:$("#productPhoto"),$productImage:$("#productPhotoImg"),$thumbImages:$("#productThumbs").find("a.product-photo-thumb"),$shareButtons:$(".social-sharing"),$collectionFilters:$("#collectionFilters"),$advancedFilters:$(".advanced-filters"),$toggleFilterBtn:$("#toggleFilters"),$emptyCart:$("#EmptyCart"),$ajaxCartContainer:$("#ajaxifyCart"),cartNoCookies:"cart--no-cookies",$featuredBoxImages:$(".featured-box--inner"),$featuredBoxTitles:$(".featured-box--title")}},timber.cacheVariables=function(){timber.vars={bpLarge:769,mediaQueryLarge:"screen and (min-width: 769px)",isLargeBp:!1,isTouch:timber.cache.$html.hasClass("supports-touch")}},timber.init=function(){timber.cacheSelectors(),timber.cacheVariables(),timber.cache.$html.removeClass("no-js").addClass("js"),"ontouchstart"in window&&timber.cache.$html.removeClass("no-touch").addClass("touch"),timber.initCart(),timber.responsiveVideos(),timber.toggleFilters()},timber.mobileNav=function(){var e={active:"nav-active",dropdownButton:"mobile-nav--button"},t={parentLink:'[data-meganav-type="parent"]',dropdownButton:"."+e.dropdownButton};timber.cache.$mobileNav.find(t.dropdownButton).on("click",function(n){var i=$(this),a=i.closest("li");i.hasClass(e.active)?i.hasClass(e.active)&&function(n,i){n.removeClass(e.active),i.removeClass(e.active),$.each(i,function(){var i=$(this);i.find("> "+t.parentLink);i.removeClass(e.active),n.attr("aria-expanded","false")})}(i,a):function(n,i){n.addClass(e.active);i.find("> "+t.parentLink);i.addClass(e.active),n.attr("aria-expanded","true")}(i,a)})},timber.accessibleNav=function(){var e={active:"nav-hover",focus:"nav-focus",outside:"nav-outside",hasDropdown:"site-nav--has-dropdown",link:"site-nav--link"},t={active:"."+e.active,hasDropdown:"."+e.hasDropdown,dropdown:"[data-meganav-dropdown]",link:"."+e.link,nextLink:"> ."+e.link,parentLink:'[data-meganav-type="parent"]',childLink:'[data-meganav-type="child"]'},n=timber.cache.$navigation,i=n.find(t.link),a=n.find(t.hasDropdown),o=n.find(t.childLink),s=a.find(t.nextLink),r=n.find(t.dropdown),c=r.find(t.link);function d(n){var i=n.parent().find(t.active);i.find(t.nextLink).attr("aria-expanded",!1),i.removeClass(e.active),timber.cache.$body.off("touchstart.MegaNav")}function l(t){var n=$(window).width();t.removeClass(e.outside),$.each(t,function(){$dropdown=$(this),$dropdown.offset().left+$dropdown.width()>n&&$dropdown.addClass(e.outside)})}a.on("mouseenter touchstart",function(i){var a=$(this),o=i.type,s=n.find(t.active);a.hasClass(e.active)||(i.preventDefault(),i.stopImmediatePropagation()),"touchstart"===o&&s.length>0&&d(a),function(i){i.find(t.nextLink).attr("aria-expanded",!0),i.addClass(e.active),setTimeout(function(){timber.cache.$body.on("touchstart.MegaNav",function(){var e;e=n.find(t.active),$.each(e,function(){d($(this))})})},250)}(a)}),o.on("touchstart",function(e){e.stopImmediatePropagation()}),a.on("mouseleave",function(){d($(this))}),i.on("focus",function(){!function(n){var a=n.parent().prev();i.attr("tabindex",""),a.hasClass(e.hasDropdown)&&a.find(t.dropdown+" "+t.link).attr("tabindex",-1);!function(t){t.addClass(e.focus),void 0!==t.attr("aria-expanded")&&t.attr("aria-expanded",!0)}(n.parents(t.hasDropdown).find("> "+t.link))}($(this))}),i.on("blur",function(){var t;(t=s).removeClass(e.focus),c.attr("tabindex",-1),void 0!==t.attr("aria-expanded")&&t.attr("aria-expanded",!1)}),timber.cache.$window.load(function(){l(r)}),timber.cache.$window.resize(function(){afterResize(function(){l(r)},250)})},timber.responsiveNav=function(){$(window).resize(function(){afterResize(function(){timber.cache.$navigation.append($("#moreMenu--list").html()),$("#moreMenu").remove(),timber.alignMenu(),timber.accessibleNav()},200,"uniqueID")}),timber.alignMenu(),timber.accessibleNav(),timber.mobileNav()},timber.alignMenu=function(){var e=timber.cache.$navigation,t=0,n=0;wrapperWidth=e.outerWidth()-101,menuhtml="",window.innerWidth<timber.vars.bpLarge||($.each(e.children(),function(){var e=$(this);e.hasClass("large-hide")||(t+=e.outerWidth(!0)),wrapperWidth<t&&(menuhtml+=$("<div>").append(e.clone()).html(),e.remove(),e.hasClass("large-hide")||n++)}),wrapperWidth<t&&(e.append('<li id="moreMenu" class="site-nav--has-dropdown"><button class="site-nav--link" data-meganav-type="parent" aria-expanded="false">'+theme.strings.navigation.more_link+'<span class="icon icon-arrow-down" aria-hidden="true"></span></button><ul id="moreMenu--list" class="site-nav--dropdown site-nav--has-grandchildren site-nav--dropdown--more">'+menuhtml+"</ul></li>"),$("#moreMenu").find("a").attr("tabindex","-1"),n<=1&&(timber.cache.$navigation.append($("#moreMenu--list").html()),$("#moreMenu").remove())))},timber.toggleMenu=function(){var e=$("#shopify-section-header"),t=$("#navBar"),n=e.find(".site-header");timber.cache.$menuToggle.on("click",function(){var i=$(this),a="true"===i.attr("aria-expanded");timber.cache.$html.toggleClass("show-nav"),i.attr("aria-expanded",!a),a?(n.removeClass("site-header--hidden"),theme.a11y.removeTrapFocus({$container:e,namespace:"mobileMenuToggle"})):(setTimeout(function(){n.addClass("site-header--hidden")},450),theme.a11y.trapFocus({$container:e,$elementToFocus:$("#MobileNav > li:first-child a"),namespace:"mobileMenuToggle"}),t.scrollTop(0)),$("#ajaxifyModal").hasClass("is-visible")&&($("#ajaxifyModal").removeClass("is-visible"),timber.cache.$html.addClass("show-nav"))})},timber.initCart=function(){"page"!=theme.settings.cartType&&ajaxifyShopify.init({method:theme.settings.cartType,wrapperClass:"wrapper",formSelector:"[data-product-form]",addToCartSelector:"#addToCart",cartCountSelector:".cart-count",toggleCartButton:".cart-toggle",useCartTemplate:!0,btnClass:"btn",moneyFormat:moneyFormat,disableAjaxCart:!1,enableQtySelectors:!0}),timber.cookiesEnabled()||(timber.cache.$emptyCart.addClass(timber.cache.cartNoCookies),timber.cache.$ajaxCartContainer.addClass(timber.cache.cartNoCookies))},timber.cookiesEnabled=function(){var e=navigator.cookieEnabled;return e||(document.cookie="testcookie",e=-1!==document.cookie.indexOf("testcookie")),e},timber.equalHeights=function(e){$(window).load(function(){timber.resizeElements(this)}),$(window).resize(function(e){afterResize(function(){timber.resizeElements(this)},250,"id")}),timber.resizeElements(this)},timber.resizeElements=function(e,t){var n=e.attr("data-section-id",t);e.find(".grid-uniform");n.find(".product-grid-image").css("height","auto").equalHeights(this);var i=e.find(".featured-box--inner"),a=e.find(".featured-box--title");i.css("height","auto").equalHeights(this),a.css("height","auto").equalHeights(this)},timber.responsiveVideos=function(){var e=$('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]'),t=e.add("iframe#admin_bar_iframe");e.each(function(){$(this).parent("div.video-wrapper").length||$(this).wrap('<div class="video-wrapper"></div>')}),t.each(function(){this.src=this.src})},timber.toggleFilters=function(){timber.cache.$collectionFilters.length&&timber.cache.$toggleFilterBtn.on("click",function(){timber.cache.$toggleFilterBtn.toggleClass("is-active"),timber.cache.$collectionFilters.slideToggle(200),$(window).scrollTop()>timber.cache.$breadcrumbs.offset().top&&$("html, body").animate({scrollTop:timber.cache.$breadcrumbs.offset().top})})},timber.sortFilters=function(){timber.cache.$advancedFilters.each(function(){var e=$(this),t=e.find("li"),n=/\d+/,i=!1;t.sort(function(e,t){return e=parseInt(n.exec($(e).text()),10),t=parseInt(n.exec($(t).text()),10),isNaN(e)||isNaN(t)?void 0:(i=!0,e-t)}),i&&e.append(t)})};

timber.formatMoney = function (val) {

  

  
  if (moneyFormat.indexOf('money') === -1) {
    if ((moneyFormat.indexOf('{{amount}}') > -1) && (moneyFormat.indexOf('.') === -1) ) {
    val = val.replace('.', '<sup>') + '</sup>';
  }
      else if ((moneyFormat.indexOf('{{ amount }}') > -1) && (moneyFormat.indexOf('.') === -1) ) {
  val = val.replace('.', '<sup>') + '</sup>';
}
      else if (moneyFormat.indexOf('{{ amount_with_comma_separator }}') > -1) {
  val = val.replace(',', '<sup>') + '</sup>';
}
else if (moneyFormat.indexOf('{{amount_with_comma_separator}}') > -1) {
  val = val.replace(',', '<sup>') + '</sup>';
}
    }


return val;
};

timber.formatSaleTag = function (val) {
  // If not using multiple currencies
  if (moneyFormat.indexOf('money') === -1) {
    // If we use amount
    if ( (moneyFormat.replace(/\s/g, '').indexOf('{{amount}}') > -1) && (moneyFormat.indexOf('.') === -1) ) {
      // If there are no cents, remove decimals
      if ( val.indexOf('.00') > -1 ) {
        return val.replace('.00', '')
      }
    }
    // If we use amount_with_comma_separator
    else if (moneyFormat.replace(/\s/g, '').indexOf('{{amount_with_comma_separator}}') > -1) {
      // If there are no cents, remove decimals
      if ( val.indexOf(',00') > -1 ) {
        return val.replace(',00', '')
      }
    }
  }
  return val;
};

// Initialize Timber's JS on docready
$(timber.init)

/*!
 * imagesLoaded PACKAGED v4.1.1
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

!function(t,e){"function"==typeof define&&define.amd?define("ev-emitter/ev-emitter",e):"object"==typeof module&&module.exports?module.exports=e():t.EvEmitter=e()}("undefined"!=typeof window?window:this,function(){function t(){}var e=t.prototype;return e.on=function(t,e){if(t&&e){var i=this._events=this._events||{},n=i[t]=i[t]||[];return-1==n.indexOf(e)&&n.push(e),this}},e.once=function(t,e){if(t&&e){this.on(t,e);var i=this._onceEvents=this._onceEvents||{},n=i[t]=i[t]||{};return n[e]=!0,this}},e.off=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){var n=i.indexOf(e);return-1!=n&&i.splice(n,1),this}},e.emitEvent=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){var n=0,o=i[n];e=e||[];for(var r=this._onceEvents&&this._onceEvents[t];o;){var s=r&&r[o];s&&(this.off(t,o),delete r[o]),o.apply(this,e),n+=s?0:1,o=i[n]}return this}},t}),function(t,e){"use strict";"function"==typeof define&&define.amd?define(["ev-emitter/ev-emitter"],function(i){return e(t,i)}):"object"==typeof module&&module.exports?module.exports=e(t,require("ev-emitter")):t.imagesLoaded=e(t,t.EvEmitter)}(window,function(t,e){function i(t,e){for(var i in e)t[i]=e[i];return t}function n(t){var e=[];if(Array.isArray(t))e=t;else if("number"==typeof t.length)for(var i=0;i<t.length;i++)e.push(t[i]);else e.push(t);return e}function o(t,e,r){return this instanceof o?("string"==typeof t&&(t=document.querySelectorAll(t)),this.elements=n(t),this.options=i({},this.options),"function"==typeof e?r=e:i(this.options,e),r&&this.on("always",r),this.getImages(),h&&(this.jqDeferred=new h.Deferred),void setTimeout(function(){this.check()}.bind(this))):new o(t,e,r)}function r(t){this.img=t}function s(t,e){this.url=t,this.element=e,this.img=new Image}var h=t.jQuery,a=t.console;o.prototype=Object.create(e.prototype),o.prototype.options={},o.prototype.getImages=function(){this.images=[],this.elements.forEach(this.addElementImages,this)},o.prototype.addElementImages=function(t){"IMG"==t.nodeName&&this.addImage(t),this.options.background===!0&&this.addElementBackgroundImages(t);var e=t.nodeType;if(e&&d[e]){for(var i=t.querySelectorAll("img"),n=0;n<i.length;n++){var o=i[n];this.addImage(o)}if("string"==typeof this.options.background){var r=t.querySelectorAll(this.options.background);for(n=0;n<r.length;n++){var s=r[n];this.addElementBackgroundImages(s)}}}};var d={1:!0,9:!0,11:!0};return o.prototype.addElementBackgroundImages=function(t){var e=getComputedStyle(t);if(e)for(var i=/url\((['"])?(.*?)\1\)/gi,n=i.exec(e.backgroundImage);null!==n;){var o=n&&n[2];o&&this.addBackground(o,t),n=i.exec(e.backgroundImage)}},o.prototype.addImage=function(t){var e=new r(t);this.images.push(e)},o.prototype.addBackground=function(t,e){var i=new s(t,e);this.images.push(i)},o.prototype.check=function(){function t(t,i,n){setTimeout(function(){e.progress(t,i,n)})}var e=this;return this.progressedCount=0,this.hasAnyBroken=!1,this.images.length?void this.images.forEach(function(e){e.once("progress",t),e.check()}):void this.complete()},o.prototype.progress=function(t,e,i){this.progressedCount++,this.hasAnyBroken=this.hasAnyBroken||!t.isLoaded,this.emitEvent("progress",[this,t,e]),this.jqDeferred&&this.jqDeferred.notify&&this.jqDeferred.notify(this,t),this.progressedCount==this.images.length&&this.complete(),this.options.debug&&a&&a.log("progress: "+i,t,e)},o.prototype.complete=function(){var t=this.hasAnyBroken?"fail":"done";if(this.isComplete=!0,this.emitEvent(t,[this]),this.emitEvent("always",[this]),this.jqDeferred){var e=this.hasAnyBroken?"reject":"resolve";this.jqDeferred[e](this)}},r.prototype=Object.create(e.prototype),r.prototype.check=function(){var t=this.getIsImageComplete();return t?void this.confirm(0!==this.img.naturalWidth,"naturalWidth"):(this.proxyImage=new Image,this.proxyImage.addEventListener("load",this),this.proxyImage.addEventListener("error",this),this.img.addEventListener("load",this),this.img.addEventListener("error",this),void(this.proxyImage.src=this.img.src))},r.prototype.getIsImageComplete=function(){return this.img.complete&&void 0!==this.img.naturalWidth},r.prototype.confirm=function(t,e){this.isLoaded=t,this.emitEvent("progress",[this,this.img,e])},r.prototype.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},r.prototype.onload=function(){this.confirm(!0,"onload"),this.unbindEvents()},r.prototype.onerror=function(){this.confirm(!1,"onerror"),this.unbindEvents()},r.prototype.unbindEvents=function(){this.proxyImage.removeEventListener("load",this),this.proxyImage.removeEventListener("error",this),this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype=Object.create(r.prototype),s.prototype.check=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this),this.img.src=this.url;var t=this.getIsImageComplete();t&&(this.confirm(0!==this.img.naturalWidth,"naturalWidth"),this.unbindEvents())},s.prototype.unbindEvents=function(){this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype.confirm=function(t,e){this.isLoaded=t,this.emitEvent("progress",[this,this.element,e])},o.makeJQueryPlugin=function(e){e=e||t.jQuery,e&&(h=e,h.fn.imagesLoaded=function(t,e){var i=new o(this,t,e);return i.jqDeferred.promise(h(this))})},o.makeJQueryPlugin(),o});


/* ================ SECTIONS ================ */
window.theme = window.theme || {};

theme.FeaturedCollections = (function() {
  function FeaturedCollections(container) {
    var $container = (this.$container = $(container));
    timber.cacheSelectors();
    timber.resizeElements($container);

    $(window).resize(function() {
      timber.resizeElements($container);
    });
  }

  return FeaturedCollections;
})();

window.theme = window.theme || {};

theme.CollectionRows = (function() {
  function CollectionRows(container) {
    var $container = (this.$container = $(container));
    var id = (this.id = $container.attr('data-section-id'));
    timber.cacheSelectors();
    timber.resizeElements($container, id);
    $(window).resize(function() {
      timber.resizeElements($container, id);
    });
  }

  return CollectionRows;
})();

window.theme = window.theme || {};

theme.Collection = (function() {
  function Collection(container) {
    var $container = (this.$container = $(container));
    var id = (this.id = $container.attr('data-section-id'));
    timber.cacheSelectors();
    timber.resizeElements($container, id);
    $(window).resize(function() {
      timber.resizeElements($container, id);
    });
  }

  return Collection;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function() {
  function Header() {
    timber.cacheSelectors();
    timber.toggleMenu();

    $(window)
      .on('load', timber.responsiveNav)
      .resize();
  }

  return Header;
})();

window.theme = window.theme || {};

theme.ListCollections = (function() {
  function ListCollections(container) {
    var $container = (this.$container = $(container));
    timber.cacheSelectors();
    timber.resizeElements($container);

    $(window).resize(function() {
      timber.resizeElements($container);
    });
  }

  return ListCollections;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];

  function Map(container) {
    theme.$currentMapContainer = this.$container = $(container);
    var key = this.$container.data('api-key');

    if (typeof key !== 'string' || key === '') {
      return;
    }

    if (apiStatus === 'loaded') {
      var self = this;

      // Check if the script has previously been loaded with this key
      var $script = $('script[src*="' + key + '&"]');
      if ($script.length === 0) {
        $.getScript('https://maps.googleapis.com/maps/api/js?key=' + key).then(
          function() {
            apiStatus = 'loaded';
            self.createMap();
          }
        );
      } else {
        this.createMap();
      }
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + key
          ).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$container.find('.map-section__container');

      return geolocate($map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              styles: config.styles,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: center
            });

            google.maps.event.addDomListener(window, 'resize', function() {
              google.maps.event.trigger(map, 'resize');
              map.setCenter(center);
            });
          }.bind(this)
        )
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = theme.strings.map.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = theme.strings.map.addressQueryLimit;
              break;
            default:
              errorMessage = theme.strings.map.addressError;
              break;
          }

          // Only show error in the theme editor
          if (Shopify.designMode) {
            var $mapContainer = $map.parents('.map-section');

            $mapContainer.addClass('page-width map-section--load-error');
            $mapContainer.find('.map-section__content-wrapper').remove();
            $mapContainer
              .find('.map-section__wrapper')
              .html(
                '<div class="errors text-center" style="width: 100%;">' +
                  errorMessage +
                  '</div>'
              );
          }
        });
    },

    onUnload: function() {
      if (typeof window.google !== 'undefined') {
        google.maps.event.clearListeners(this.map, 'resize');
      }
    }
  });

  return Map;
})();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure() {
  if (!Shopify.designMode) return;

  theme.$currentMapContainer.addClass('page-width map-section--load-error');
  theme.$currentMapContainer.find('.map-section__content-wrapper').remove();
  theme.$currentMapContainer
    .find('.map-section__wrapper')
    .html(
      '<div class="errors text-center" style="width: 100%;">' +
        theme.strings.map.authError +
        '</div>'
    );
}

/* eslint-disable no-new */
theme.Product = (function() {
  var defaults = {
    selectors: {
      addToCart: '#addToCart',
      productPrice: '#productPrice',
      comparePrice: '#comparePrice',
      addToCartText: '#addToCartText',
      quantityElements: '.quantity-selector, label + .js-qty',
      optionSelector: 'productSelect'
    }
  };

  function Product(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');

    this.settings = $.extend({}, defaults, {
      sectionId: sectionId,
      enableHistoryState: true,
      showComparePrice: $container.attr('data-show-compare-at-price'),
      ajaxCartMethod: $container.attr('data-ajax-cart-method'),
      stockSetting: $container.attr('data-stock'),
      incomingMessage: $container.attr('data-incoming-transfer'),
      genericIncomingMessage: $container.attr('data-generic-incoming'),
      currentVariant: false,
      selectors: {
        unitPriceContainer: '[data-unit-price-container]',
        unitPrice: '[data-unit-price]',
        unitPriceBaseUnit: '[data-unit-price-base-unit]',
        priceContainer: '[data-price]',
        originalSelectorId: 'productSelect-' + sectionId,
        $addToCart: $('#addToCart-' + sectionId),
        $SKU: $('.variant-sku', this.$container),
        $productPrice: $('#productPrice-' + sectionId),
        $comparePrice: $('#comparePrice-' + sectionId),
        $addToCartText: $('#addToCartText-' + sectionId),
        $quantityElements: $('#quantity-selector-' + sectionId),
        $variantQuantity: $('#variantQuantity-' + sectionId),
        $variantQuantityMessage: $('#variantQuantity-' + sectionId + '__message'),
        $variantIncoming: $('#variantIncoming-' + sectionId),
        $variantIncomingMessage: $('#variantIncoming-' + sectionId + '__message'),
        $productImageContainer: $('#productPhotoContainer-' + sectionId),
        $productImageWrapper: $('[id^="productPhotoWrapper-' + sectionId + '"]'),
        $productImage: $('[id^="productPhotoImg-' + sectionId + '"]'),
        $taxPreference: $('#tax_preference'),
        $productFullDetails: $('.full-details', this.$container),
        $thumbImages: $('#productThumbs-' + sectionId).find('a.product-photo-thumb'),
        $shopifyPaymentButton: '.shopify-payment-button'
      }
    });

    // disable history state if on homepage
    if($('body').hasClass('template-index')) {
      this.settings.enableHistoryState = false;
    }

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.zoomEnabled = $container.attr('data-zoom-enabled');

    // this.productSingleObject = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);
    this.productSingleObject = JSON.parse($('#ProductJson-' + sectionId).html());
    this.addVariantInfo();
    this.init();

    // Pre-loading product images to avoid a lag when a thumbnail is clicked, or
    // when a variant is selected that has a variant image
    Shopify.Image.preload(this.productSingleObject.images);

    if (this.settings.ajaxCartMethod != 'page') {
      ajaxifyShopify.init({
        method: 'page',
        wrapperClass: 'wrapper',
        formSelector: '[data-product-form]',
        addToCartSelector: '#addToCart-' + sectionId,
        cartCountSelector: '.cart-count',
        toggleCartButton: '.cart-toggle',
        useCartTemplate: true,
        btnClass: 'btn',
        moneyFormat: moneyFormat,
        disableAjaxCart: false,
        enableQtySelectors: true
      });
    }
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    init: function() {
      this.initProductVariant();
      this.addQuantityButtons();
      this.productImageSwitch();
      this.taxSwitch();
      this.initBreakpoints();

      if (timber.vars.isLargeBp && this.zoomEnabled) {
        productImageZoom();
      }
    },

    onUnload: function() {
      this.$container.off(this.settings.sectionId);
    },

    addVariantInfo: function() {
      if (!this.productSingleObject) {
        return;
      }

     
      if (this.settings.stockSetting === 'false' && this.settings.incomingMessage === 'false'){
        return;
      }

      var variantInfo = JSON.parse($('#VariantJson-' + this.settings.sectionId, this.$container).html());
      for (var i = 0; i < variantInfo.length; i++) {
        $.extend(this.productSingleObject.variants[i], variantInfo[i]);             
        this.productSingleObject.variants[i].bundle = $('#bundle_'+this.productSingleObject.variants[i].id).data('json');
      }

      
    },

    addQuantityButtons: function(){
      if (this.settings.selectors.$quantityElements){
        this.settings.selectors.$quantityElements.show();
        
      }

    },

    qtySelectors: function() {

      validateQty = function (qty) {
        if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
          // We have a valid number!
          return qty;
        } else {
          // Not a number. Default to 1.
          return 1;
        }
      };

      // Change number inputs to JS ones, similar to ajax cart but without API integration.
      // Make sure to add the existing name and id to the new input element
      var numInputs = $('input[type="number"]', this.$container);

      // Qty selector has a minimum of 1 on the product page
      // and 0 in the cart (determined on qty click)
      var qtyMin = 0;

      if (numInputs.length) {
        numInputs.each(function() {
          var el = $(this),
          currentQty = parseInt(el.val()),
          inputName = el.attr('name'),
          inputId = el.attr('id');

          var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

          var source = $("#jsQty").html(),
          template = Handlebars.compile(source),
          data = {
            key: el.data('id'),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus,
            inputName: inputName,
            inputId: inputId
          };

          // Append new quantity selector then remove original
          el.after(template(data)).remove();
        });

        // Setup listeners to add/subtract from the input
        $('.js--qty-adjuster', this.$container).on('click', function() {
          var el = $(this),
          id = el.data('id'),
          qtySelector = el.siblings('.js--num'),
          qty = parseInt( qtySelector.val() );

          var qty = validateQty(qty);
          qtyMin = timber.cache.$body.hasClass('template-product') ? 1 : qtyMin;

          // Add or subtract from the current quantity
          if (el.hasClass('js--add')) {
            qty = qty + 1;
          } else {
            qty = qty <= qtyMin ? qtyMin : qty - 1;
          }

          // Update the input's number
          qtySelector.val(qty);
        });

      }
    },

    initBreakpoints: function () {

      var self = this;
      var $container = self.$container;
      self.zoomType = $container.data('zoom-enabled');

      enquire.register(timber.vars.mediaQueryLarge, {
        match: function() {
          timber.vars.isLargeBp = true;
          if (self.zoomType) {
            // reinit product zoom
            productImageZoom();
          }

        },
        unmatch: function() {
          timber.vars.isLargeBp = false;
          if (self.zoomType) {

            if ((self.settings.selectors.$productImage).length) {
              // remove event handlers for product zoom on mobile
                self.settings.selectors.$productImage.off();
                self.settings.selectors.$productImageWrapper.trigger('zoom.destroy');
            }
          }

        }
      });
    },

    taxSwitch: function() {
      if (!this.settings.selectors.$taxPreference.length) {
        return;
      }

      var self = this;

      //Updates prices based on the tax switch
      self.settings.selectors.$taxPreference.on('change', function(evt) {
        self.displayPrices(self.productSingleObject.variants);
        console.log(self.productSingleObject.variants);
      });
    },    
    
    productImageSwitch: function() {
      if (!this.settings.selectors.$thumbImages.length) {
        return;
      }

      var self = this;

      // Switch the main image with one of the thumbnails
      // Note: this does not change the variant selected, just the image
      self.settings.selectors.$thumbImages.on('click', function(evt) {
        evt.preventDefault();
        var newImageId = $(this).attr('data-image-id');
        self.switchImage(newImageId);
      });
    },

    switchImage: function (imageId) {
      var $newImage = this.settings.selectors.$productImageWrapper.filter('[data-image-id="' + imageId + '"]');
      var $otherImages = this.settings.selectors.$productImageWrapper.not('[data-image-id="' + imageId + '"]');
      $newImage.removeClass('hide');
      $otherImages.addClass('hide');

      if ($newImage.find('img').attr('data-zoom') && timber.vars.isLargeBp) {
        productImageZoom();
      }
    },

    initProductVariant: function() {
      // this.productSingleObject is a global JSON object defined in theme.liquid
      if (!this.productSingleObject) {
        return;
      }

      console.log("Variant initiated");
      
      var self = this;
      this.optionSelector = new Shopify.OptionSelectors(self.settings.selectors.originalSelectorId, {
        selectorClass: self.settings.selectors.$optionSelectorClass,
        product: self.productSingleObject,
        onVariantSelected: self.productVariantCallback.bind(self),
        enableHistoryState: self.settings.enableHistoryState,
        settings: self.settings
      });

      // Clean up variant labels if the Shopify-defined
      // defaults are the only ones left
      this.simplifyVariantLabels(this.productSingleObject);

      self.displayPrices();
    },

    displayPrices: function() {
        console.log("Diplay Prices called");
        //Determine prices based on the customer's tax preference
        if (!this.settings.currentVariant) {
          return;
        }       
        variant = taxHandler.determineTax(this.settings.currentVariant);
      
        
        var price = (taxHandler.getTaxPreference())?variant.tax_price:variant.price;
        var compare_at_price = (taxHandler.getTaxPreference())?variant.tax_compare_at_price:variant.compare_at_price;
        
        console.log("Loaded Price: "+price);

        // Regardless of stock, update the product price
        var customPrice = timber.formatMoney( Shopify.formatMoney(price, moneyFormat) );
        var a11yPrice = Shopify.formatMoney(price, moneyFormat);
        var customPriceFormat = ' <span aria-hidden="true">' + customPrice + '</span>';
        customPriceFormat += ' <span class="visually-hidden">' + a11yPrice + '</span>';

        // Show SKU
        this.settings.selectors.$SKU.html(variant.sku)

        if (this.settings.showComparePrice == 'true' ) {
          if (compare_at_price > price) {
            var comparePrice = timber.formatMoney(Shopify.formatMoney(compare_at_price, moneyFormat));
            var a11yComparePrice = Shopify.formatMoney(compare_at_price, moneyFormat);

            customPriceFormat = ' <span aria-hidden="true">' + customPrice + '</span>';
            customPriceFormat += ' <span aria-hidden="true"><s>' + comparePrice + '</s></span>';
            customPriceFormat += ' <span class="visually-hidden"><span class="visually-hidden">Regular price</span> ' + a11yComparePrice + '</span>';
            customPriceFormat += ' <span class="visually-hidden"><span class="visually-hidden">Sale price</span> ' + a11yPrice + '</span>';
          }
        }
        this.settings.selectors.$productPrice.html(customPriceFormat);

        // Also update and show the product's compare price if necessary
        if ( compare_at_price > price ) {
          var priceSaving = timber.formatSaleTag( Shopify.formatMoney(compare_at_price - price, moneyFormat) );
          
          this.settings.selectors.$comparePrice.html("Save [$]".replace('[$]', priceSaving)).show();
        } else {
          this.settings.selectors.$comparePrice.hide();
        }

    },
    
    simplifyVariantLabels: function(productObject) {
      // Hide variant dropdown if only one exists and title contains 'Default'
      if (productObject.variants.length === 1 && productObject.options.length === 1 && productObject.options[0].toLowerCase().indexOf('title') >= 0 && productObject.variants[0].title.toLowerCase().indexOf('default title') >= 0) {
        $('.selector-wrapper', this.$container).hide();
      }
    },

    productVariantCallback: function(variant) {
      var self = this;
    this.settings.currentVariant = variant;
      
      if (variant) {
        //  Only change unit price for main product
        var $priceContainer = $(this.settings.selectors.priceContainer, this.$container);

        // Update unit price, if one is set
        var $unitPriceContainer = $(this.settings.selectors.unitPriceContainer, $priceContainer);

        $unitPriceContainer.removeClass('product-price-unit--available');

        if (variant.unit_price_measurement) {
          var $unitPrice = $(this.settings.selectors.unitPrice, $priceContainer);
          var $unitPriceBaseUnit = $(this.settings.selectors.unitPriceBaseUnit, $priceContainer);

          $unitPrice.text(Shopify.formatMoney(variant.unit_price, moneyFormat));
          $unitPriceBaseUnit.text(this.getBaseUnit(variant));
          $unitPriceContainer.addClass('product-price-unit--available');
        }

        // Update variant image, if one is set
        if (variant.featured_image) {
          var newImg = variant.featured_image;
          var $newImage = this.settings.selectors.$productImageWrapper.filter('[data-image-id="' + newImg.id + '"]');
          var $otherImages = this.settings.selectors.$productImageWrapper.not('[data-image-id="' + newImg.id + '"]');

          $newImage.removeClass('hide');
          $otherImages.addClass('hide');
        }

        
        //Remove any bundle-related information
          Array.from(document.querySelectorAll('.bundles_lineitemProperty')).forEach(function(item) {
            item.parentNode.removeChild(item)
          });
        
        if (variant.available) {
          
          
          // We have a valid product variant, so enable the submit button
          this.settings.selectors.$addToCart.removeClass('disabled').prop('disabled', false);
          this.settings.selectors.$addToCartText.html("Add to Cart");
          $(this.settings.selectors.$shopifyPaymentButton, this.$container).show();

          this.settings.selectors.$variantQuantity.removeClass('is-visible');
          this.settings.selectors.$variantIncoming.removeClass('is-visible');

          var $link = this.settings.selectors.$productFullDetails;
          if ($link.length) {
            $link.attr('href', updateUrlParameter($link.attr('href'), 'variant', variant.id));
          }

          if (variant.inventory_management) {
            // Show how many items are left, if below 10
            if (variant.inventory_quantity < 10 && variant.inventory_quantity > 0 && this.settings.stockSetting == 'true') {
              this.settings.selectors.$variantQuantityMessage.html(theme.strings.product.only_left.replace('1', variant.inventory_quantity));
              this.settings.selectors.$variantQuantity.addClass('is-visible');
            }
          }

          // Show next ship date if quantity <= 0 and stock is incoming
          if (variant.inventory_quantity <= 0 && variant.incoming != null ) {
            if (variant.next_incoming_date != null){
              this.settings.selectors.$variantIncomingMessage.html((this.settings.genericIncomingMessage)?theme.strings.product.backorder:theme.strings.product.will_be_in_stock_after.replace('[date]', variant.next_incoming_date));
              this.settings.selectors.$variantIncoming.addClass('is-visible')
            }
          }
          
          if (variant.bundle == null) { 
            //console.log("No Bundle");
          } else {
            if (variant.bundle.length > 0) {
              //console.log('Adding Bundle');

              //2022-02-15: Commented to allow for multiple languages
              //Language is prepended to the URL, creating issues.
              //var cartForm = document.querySelector("form[action='/cart/add']");
              var cartForm = document.getElementById("addToCartForm-product-template")

              for (var i = 0; i < variant.bundle.length; i++) {

                var itemNo = i +1;

                // CREATE LINE ITEM PROPERTIES, IF YOU WANT TO SHOW THEM IN CART AND CHECKOUT, REMOVE _ BEFORE PRODUCT
                var inputName = 'properties[_Product '+itemNo+']';
                if( variant.bundle[i].sku != null){
                  var inputValue = variant.bundle[i].quantity + 'x ' +variant.bundle[i].sku;
                }else{
                  var inputValue = variant.bundle[i].quantity + 'x ' + variant.bundle[i].title;
                }
                var lineItemPropertyInput = document.createElement("input");
                lineItemPropertyInput.setAttribute('class', 'bundles_lineitemProperty');
                lineItemPropertyInput.setAttribute('name', inputName);
                lineItemPropertyInput.setAttribute('type', 'hidden');
                lineItemPropertyInput.setAttribute('value', inputValue);

                cartForm.appendChild(lineItemPropertyInput);
              }

            }
          }
          
        } else {

          // Variant is sold out, disable the submit button
          this.settings.selectors.$addToCart.addClass('disabled').prop('disabled', true);
          this.settings.selectors.$addToCartText.html("Sold Out");
          $(this.settings.selectors.$shopifyPaymentButton, this.$container).hide();

          this.settings.selectors.$variantQuantity.removeClass('is-visible');
          this.settings.selectors.$variantIncoming.removeClass('is-visible');

          // Show next stock incoming date if stock is incoming
          if (variant.inventory_management) {
            if (variant.incoming && this.settings.incomingMessage == 'true' && variant.incoming != null && variant.next_incoming_date != null) {
              this.settings.selectors.$variantIncoming.html((this.settings.genericIncomingMessage)?theme.strings.product.backorder:theme.strings.product.will_be_in_stock_after.replace('[date]', variant.next_incoming_date)).addClass('is-visible');
            }
          }

          this.settings.selectors.$quantityElements.hide();
        }
        
        //Determine prices based on the customer's tax preference
        variant = taxHandler.determineTax(variant);

        
        var price = (taxHandler.getTaxPreference())?variant.tax_price:variant.price;
        var compare_at_price = (taxHandler.getTaxPreference())?variant.tax_compare_at_price:variant.compare_at_price;

        // Regardless of stock, update the product price
        var customPrice = timber.formatMoney( Shopify.formatMoney(variant.price, moneyFormat) );
        var a11yPrice = Shopify.formatMoney(variant.price, moneyFormat);
        var customPriceFormat = ' <span aria-hidden="true">' + customPrice + '</span>';
        customPriceFormat += ' <span class="visually-hidden">' + a11yPrice + '</span>';

        // Show SKU
        this.settings.selectors.$SKU.html(variant.sku)

        if (this.settings.showComparePrice == 'true' ) {
          if (variant.compare_at_price > variant.price) {
            var comparePrice = timber.formatMoney(Shopify.formatMoney(variant.compare_at_price, moneyFormat));
            var a11yComparePrice = Shopify.formatMoney(variant.compare_at_price, moneyFormat);

            customPriceFormat = ' <span aria-hidden="true">' + customPrice + '</span>';
            customPriceFormat += ' <span aria-hidden="true"><small><s>' + comparePrice + '</s></small></span>';
            customPriceFormat += ' <span class="visually-hidden"><span class="visually-hidden">Regular price</span> ' + a11yComparePrice + '</span>';
            customPriceFormat += ' <span class="visually-hidden"><span class="visually-hidden">Sale price</span> ' + a11yPrice + '</span>';
          }
        }
        this.settings.selectors.$productPrice.html(customPriceFormat);

        // Also update and show the product's compare price if necessary
        if ( variant.compare_at_price > variant.price ) {
          var priceSaving = timber.formatSaleTag( Shopify.formatMoney(variant.compare_at_price - variant.price, moneyFormat) );
          // priceSaving += ' (' + ( (variant.compare_at_price - variant.price)*100/(variant.compare_at_price) ).toFixed(0) + '%)';
          this.settings.selectors.$comparePrice.html("Save [$]".replace('[$]', priceSaving)).show();
        } else {
          this.settings.selectors.$comparePrice.hide();
        }

      } else {
        // The variant doesn't exist, disable submit button.
        // This may be an error or notice that a specific variant is not available.
        this.settings.selectors.$addToCart.addClass('disabled').prop('disabled', true);
        this.settings.selectors.$addToCartText.html(theme.strings.product.unavailable);
        this.settings.selectors.$variantQuantity.removeClass('is-visible');
        this.settings.selectors.$quantityElements.hide();
        $(this.settings.selectors.$shopifyPaymentButton, this.$container).hide();
      }
      //Variant updated, set appropriate prices
      console.log("Variant updated, correcting prices..");
      self.displayPrices();
    },

    getBaseUnit: function (variant) {
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  });

  function updateUrlParameter(url, key, value) {
    var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
    var separator = url.indexOf('?') === -1 ? '?' : '&';

    if (url.match(re)) {
      return url.replace(re, '$1' + key + '=' + value + '$2');
    } else {
      return url + separator + key + '=' + value;
    }
  }

  function productImageZoom() {
    var $productImageWrapper = $('.product__image-wrapper');

    if (timber.vars.isLargeBp) {
      if (!$productImageWrapper.length || timber.cache.$html.hasClass('supports-touch')) {
        return;
      };

      // Destroy zoom (in case it was already set), then set it up again
      $productImageWrapper.trigger('zoom.destroy');
      $productImageWrapper.each(function() {
        if($(this).find('img').attr('data-zoom')){
          $(this).addClass('image-zoom').zoom({
            url: $(this).find('img').attr('data-zoom'),
            onZoomIn: function() {
                $(this).prev('img').hide();
            },
            onZoomOut: function() {
                $(this).css('opacity', '0');
                $(this).prev('img').show();
            }
          })
        }
      });
    }
  }

  return Product;

})();

window.theme = window.theme || {};

theme.Search = (function() {
  function Search(container) {
    var $container = (this.$container = $(container));
    timber.cacheSelectors();
    timber.resizeElements($container);

    $(window).resize(function() {
      timber.resizeElements($container);
    });
  }

  return Search;
})();

theme.tax = function(sDefault, sTax) {
  var taxRate;
  var selectorDefault = sDefault;
  var selectorTax = sTax;
  return {
    initPrices: function() {
      if (this.getTaxPreference()) {
        $(selectorDefault).hide();
        $(selectorTax).show();
      } else {
        $(selectorDefault).show();
        $(selectorTax).hide();
      }
    },
    determineTax: function(variant) {
      if(this.getTaxPreference()) {
        variant.tax_price = variant.price * this.taxRate;
        variant.tax_compare_at_price = variant.compare_at_price * this.taxRate;
      } 
      return variant;
    },
    getTaxPreference: function() { 
      return (localStorage.getItem("tax_preference") === "true")?true:false;
    },
    setTaxPreference: function(taxPreference) {
      localStorage.setItem("tax_preference", taxPreference+"");
      return true;
    },
    setTaxRate: function(taxRate) {
      this.taxRate = taxRate
    },
    setDefaultTaxPreference: function(defaultMode) {
      defaultMode = (defaultMode === true)?true:false;

      //Check to see if we have a preference set ..
      if (localStorage.getItem("tax_preference") === null) {
      console.log("No default mode found, setting to: "+defaultMode);      
        this.setTaxPreference(defaultMode)
      }

    },
    getTaxRate: function() {
      return this.taxRate; 
    }   
  }
};

var is_bound = false;
initAjaxCart = function (obj) {
  // Do all cart things here

  // If running as the ajax cart callback, an object is returned
  if (obj.is_visible) {
    // the cart is shown
    //console.log('Ajax Cart Visible');
    if (!is_bound) performVATBind();
    
    //Show correct prices in the cart
    taxHandler.initPrices();

  } else {
    // the cart was hidden
    //console.log('Ajax Cart Hidden');
  }
};

function a11yClick(event){
    if(event.type === 'click'){
        return true;
    }
    else if(event.type === 'keypress'){
        var code = event.charCode || event.keyCode;
        if((code === 32)|| (code === 13)){
            return true;
        }
    }
    else{
        return false;
    }
}

function performVATBind() {
  //Reset the form "submit_flag" when the VAT No or Email are modified. 
  //Form will need to go through validation again
  $('input#vat_reg_no').on("keyup change", function() {
    if ($('input#vat_reg_no').val() != "") {
      if ($('input#vat_email').attr('type') != 'hidden') $('#vat-email-box').fadeIn(500);
    } else {
      if ($('input#vat_email').attr('type') != 'hidden') $('#vat-email-box').fadeOut(500);
    }
  });

  $('#vat_validate').on('click keypress', function() {
     //If we have a click or a keypress on the validate button
     if(a11yClick(event) === true){
    
        if ($('input#vat_reg_no').val() != "") {
          //Check we have a valid email
          if ($('input#vat_email').val() != "") {
            console.log("VATBind: Email set");
            $.ajax({
              type : "GET",
              dataType: "jsonp",
              url: "/apps/sufio/customer-vat/",
              data: { email: $('input#vat_email').val(), vat_no: $('input#vat_reg_no').val() },
              error: function (xhr, ajaxOptions, thrownError) {
                console.log("VATBind: Generic fail");
                $('input#vat_email')[0].setCustomValidity($('input#vat_email').data("error-message"));
                $('input#vat_email').prop("required", "required");
                $('input#vat_email')[0].reportValidity();
                $('input#vat_email').removeProp("required");
              },
              beforeSend: function( xhr ) {
          $('#validation_pulse').fadeIn(500);
                $('#btn_validate_text').html('Validating');
                                             
        //Disable the checkout button
                $('#cart-form button[type=submit]').attr("disabled", true);
          },
              complete: function() {
          $('#validation_pulse').fadeOut(500);
                $('#btn_validate_text').html('Validate');

        //Disable the checkout button
                $('#cart-form button[type=submit]').attr("disabled", false);
              },
              success: function(data) {
                if (data.result) {
                  console.log('VATBind: VAT Approved');
                  // Proceed to checkout after successfully sending the VAT number
                  var form_action = document.getElementById('cart-form').action + '?checkout[email]=' + encodeURIComponent($('input#vat_email').val());
                  $('#cart-form').attr('action',form_action);
                 
                  //Success: Hide the form, show the status
                  $('#vat_form').fadeOut(500);
                  $('#vat_status').html('Valid ☑️');
                  $('#vat_status').fadeIn(500);

                  //Toggle the VAT Slider to Disable VAT Pricing
                  //Update the tax slider
                  taxHandler.setTaxPreference(false);
                  $('#tax_preference').prop("checked", false);
                  taxHandler.initPrices(); 

                } else {
                  //Error: Show the form, show the error
                  $('#vat_form').fadeIn(500);
                  $('#vat_status').html('Invalid ❌');
                  $('#vat_status').fadeIn(500);
                                    
                  console.log('VATBind: VAT Failed, triggering error');
                  $('#vat_validate')[0].setCustomValidity($('#vat_validate').data("error-message"));
                  $('#vat_validate').prop("required", "required");
                  $('#vat_validate')[0].reportValidity();
                  $('#vat_validate').removeProp("required");                   
                }
              }
            });
            event.preventDefault();
          } else {
            $('#vat_form').fadeIn(500);
            $('#vat_status').html('Invalid ❌');
      $('#vat_status').fadeIn(500);
            console.log("VATBind: Email empty.. triggering error");
            $('input#vat_email')[0].setCustomValidity($('input#vat_email').data("error-message"));
            $('input#vat_email').prop("required", "required");
            $('input#vat_email')[0].reportValidity();
            $('input#vat_email').removeProp("required");
            event.preventDefault();
          }
        }
        

     }

  });
};  
  

theme.Slideshow = function(el) {
  this.cache = {
    $slider: $(el),
    sliderArgs: {
      animation: 'slide',
      animationSpeed: 500,
      pauseOnHover: true,
      keyboard: false,
      slideshow: $(el).data('slider-home-auto'),
      slideshowSpeed: $(el).data('slider-home-rate'),
      controlNav: ($(el).data('slider-controls') == false) ? false: true,
      smoothHeight: true,
      before: function(slider) {
        $(slider).resize();
        $(slider)
          .find('.slide')
          .not('.flex-active-slide')
          .removeClass('slide-hide');
      },
      after: function(slider) {
        $(slider)
          .find('.slide')
          .not('.flex-active-slide')
          .addClass('slide-hide');
        $(slider).resize();
      },
      start: function(slider) {
        $(slider)
          .find('.slide')
          .not('.flex-active-slide')
          .addClass('slide-hide');
        if (
          $(slider)
            .find('.slide')
            .not('.clone').length === 1
        ) {
          $(slider)
            .find('.flex-direction-nav')
            .remove();
        }
        $(window).trigger('resize');
        slider.addClass('loaded');
        if ($('#slider').data('loaded-index') !== undefined) {
          $('#slider').flexslider($('#slider').data('loaded-index'));
        }
      }
    }
  };
  if (this.cache.$slider.find('li').length === 1) {
    this.cache.sliderArgs.touch = false;
  }
  this.cache.$slider.flexslider(this.cache.sliderArgs);
};

theme.slideshows = theme.slideshows || {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container));
    var id = $container.attr('data-section-id');
    var slideshow = (this.slideshow = '#heroSlider--' + id);
    var numberOfSlides = $(slideshow).find('li').length;

    if (numberOfSlides <= 0) return;

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);
      var $slide = $('#slide--' + evt.detail.blockId + ':not(.clone)');

      var slideIndex = $slide.data('flexslider-index');
      var $slideImg = $slide.find('img') || $slide.find('svg');

      $slide.imagesLoaded($slideImg, function() {
        $slideshow.flexslider(slideIndex);
        $slideshow.resize();
        $slideshow.flexslider('pause');
      });
    },

    onBlockDeselect: function() {
      $(this.slideshow).flexslider('play');
    }
  }
);

  /* Load the VAT Toggle */
  taxHandler = new theme.tax('[data-no-tax]','[data-tax]');
  //Set to true for prices incl. tax by default, false for excl. tax. 
  taxHandler.setTaxRate(1.2);

function geoip(json){
    EEAList = ["BE", "BG", "CY", "DK", "DE", "ES", "FI", "FR", "GR", "HU", "IE", "IS", "IT", "HR", "LV", "LI", "LU", "MT", "NL", "NO", "AT", "PL", "PT", "RO", "SI", "SK", "EE", "CZ", "SE", "CH"];
    if (EEAList.includes(json.country_code.toUpperCase())) {
        console.log("EU Country detected, setting TVA");
        taxHandler.setDefaultTaxPreference(true); 
    } else {
      console.log("Non EU Country detected, unsetting TVA");
      taxHandler.setDefaultTaxPreference(false); 
    }

  //Run shipping estimation scripts

  if ($('#shipping-country').length) {
    $('#shipping-country').val(json.country_code.toLowerCase()).trigger( "change" );

  }
}

$(document).ready(function() {
  /* Fire the VAT Toggle */  
  console.log("Firing TVA Toggle")
  taxHandler.initPrices();
  
  //Update the tax slider
  $('#tax_preference').prop("checked", taxHandler.getTaxPreference());
   
  //Bind the tax slider
  $('#tax_preference').change(function() {
    taxHandler.setTaxPreference(this.checked);
    taxHandler.initPrices();
  });  
  
  
  var sections = new theme.Sections();
  sections.register('collections-list-template', theme.FeaturedCollections);
  sections.register('collection-row-section', theme.CollectionRows);
  sections.register('collection-template', theme.Collection);
  sections.register('header-section', theme.HeaderSection);
  sections.register('list-collections-template', theme.ListCollections);
  sections.register('map-section', theme.Maps);
  sections.register('product-template', theme.Product);
  sections.register('search-template', theme.Search);
  sections.register('slideshow-section', theme.SlideshowSection);
 
  
  /* Load Tabs */
    $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  
  
  /* Add Blog / News / Links */
 $("#blog-target").html($('#hidden-blog-contents').html());  
 $("#tutorial-target").html($('#hidden-tutorial-contents').html());
 $("#links-target").html($('#hidden-news-contents').html());  
  


});
